'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

var Table = /*#__PURE__*/function () {
  function Table(name) {
    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    _classCallCheck__default["default"](this, Table);
    _defineProperty__default["default"](this, "headers", []);
    // Only support sorting on the columns with primitive data.
    _defineProperty__default["default"](this, "sortables", []);
    _defineProperty__default["default"](this, "rows", []);
    this.name = name;
    this.headers = headers;
    this.rows = rows;
  }

  /**
   * Add one row to table.
   *
   * @param {any} row
   * @memberof Table
   */
  return _createClass__default["default"](Table, [{
    key: "addRow",
    value: function addRow(row) {
      this.rows.push(row);
    }

    /**
     * Set table header.
     *
     * @param {string[]} headers
     * @memberof Table
     */
  }, {
    key: "setHeaders",
    value: function setHeaders(headers) {
      this.headers = headers;
    }
  }]);
}();

exports.Table = Table;
